const getUnderModalClass = (isUnder = false) => {
  return isUnder ? 'csw-under-modal' : undefined;
};

export default getUnderModalClass;
